var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadScript } from './loadScript';
export const loadDependencies = (bkashScriptURL) => __awaiter(void 0, void 0, void 0, function* () {
    if (!document.querySelector('#jquery')) {
        yield loadScript('https://code.jquery.com/jquery-3.3.1.min.js', 'jquery');
    }
    if (!document.querySelector('#bkashScript')) {
        yield loadScript(bkashScriptURL, 'bkashScript');
    }
});
//# sourceMappingURL=loadDeps.js.map